<template>
  <div>
    <!-- <div class="banner page-head flex-box">
      <div class="w-100">
        <div class="container">
          <div class="banner-caption">
            <h3>Blog Post</h3>
            <p>Our Work is the bridge to various insightful digital experiences.</p>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="spinner"
      id="spinner"
      v-show="spinnerOn"
    ></div>
    <div class="blog-wrp">
      <div class="container">
        <div class="row">
          <div class="col-md-7 col-lg-9">
            <div class="blog-detail">
              <div class="blog-img">
                <img class="js-lazy-image" :src="blog.img" alt>
              </div>
              <h3 class="mt-3 blog-det-heading">{{blog.title}}</h3>
              <div class="blog-desc">
                <p v-html="blog.content">{{blog.content}}</p>
              </div>
              <div class="blog-det d-flex flex-wrap justify-content-between">
                <ul class="det">
                  <li>By: {{blog.by}}</li>
                  <li>{{blog.date}}</li>
                </ul>
                <!-- <ul class="b-social d-flex">
                  <li>
                    <a href>
                      <img src="/static/images/fb.png" alt>
                    </a>
                  </li>
                  <li>
                    <a href>
                      <img src="/static/images/insta.png" alt>
                    </a>
                  </li>
                  <li>
                    <a href>
                      <img src="/static/images/in.png" alt>
                    </a>
                  </li>
                </ul>-->
              </div>
            </div>
            <!-- <div class="blog-pagin">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item first">
                    <a class="page-link" href="#">
                      <img class="mr-2" src="/static/images/left-ar.png" alt>Older Page
                    </a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" href="#">1</a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" href="#">2</a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" href="#">3</a>
                  </li>
                  <li class="page-item last">
                    <a class="page-link" href="#">
                      Next Page
                      <img class="ml-2" src="/static/images/right-ar.png" alt>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>-->
          </div>
          <div class="col-md-5 col-lg-3">
            <div class="sidebar">
              <div class="search">
                <form>
                  <div class="form-group">
                    <input
                      type="search"
                      class="form-control"
                      id
                      placeholder="Search..."
                      @keydown.enter="search_post"
                      v-model="search_input"
                    >
                    <!-- <button type="submit" class @click="search_bar">
                      <img class="js-lazy-image" data-src="/static/images/search.png" alt>
                    </button> -->
                  </div>
                </form>
              </div>
              <div class="recent">
                <h3>Recent Posts</h3>
                <div
                  class="recent-blk d-flex flex-wrap"
                  v-for="(post, index) in filteredBlogs"
                  :key="index"
                  @click="show_post(index)"
                  style="cursor: pointer;"
                >
                  <div class="recent-img">
                    <img class="js-lazy-image" :src="post.img" alt>
                  </div>
                  <div class="recent-desc">
                    <h6>{{post.title}}</h6>
                    <!-- <ul class="det">
                      <li>By: {{post.by}}</li>
                      <li>{{post.date}}</li>
                    </ul> -->
                  </div>
                </div>
              </div>
              <!-- <div class="category">
                <h3>CATEGORIES</h3>
                <ul class="cate-list">
                  <li>
                    <a href="#" class="d-flex justify-content-between">
                      <span class>Marketing</span>
                      <span class="cate-badge">[{{categories.marketing}}]</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="d-flex justify-content-between">
                      <span class>Technology</span>
                      <span
                        class="cate-badge"
                        v-show="categories.technology!=0"
                      >[{{categories.technology}}]</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="d-flex justify-content-between">
                      <span class>Consultancy</span>
                      <span class="cate-badge">[{{categories.consultancy}}]</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="d-flex justify-content-between">
                      <span class>Finance</span>
                      <span class="cate-badge">[{{categories.finance}}]</span>
                    </a>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import axios from "axios";
export default {
  data() {
    return {
      blog: {
        title: "",
        content: "",
        by: "Amit",
        date: "",
        img: ""
      },
      recent_posts: [],
      search_input: "",
      categories: {
        marketing: 1,
        technology: 2,
        consultancy: 0,
        finance: 0
      },
      show_blogs_list: process.env.SHOW_BLOGS_LIST,
      observer: null,
      blogs_list: [],
      spinnerOn: false,
    };
  },
  methods: {
    search_post() {
      // console.log("Enter works");
      // if (this.search_input != "") {
      //   this.spinnerOn = true;
      //   axios
      //     .post('https://api.cense.ai/bot/v1/home/blog-list',
      //       {
              
      //       },
      //       {
      //         headers: {
      //           Authorization: `Bearer ${this.$session.get("at")}`,
      //         },
      //       }
      //     )
      // }
      event.preventDefault();
    },
    setIntersectionObserver() {
      // Get all of the images that are marked up to lazy load
      const images = document.querySelectorAll('.js-lazy-image');
      const config = {
        // If the image gets within 50px in the Y axis, start the download.
        rootMargin: '50px 0px',
        threshold: 0.01
      };
      // The observer for the images on the page
      // If we don't have support for intersection observer, load the images immediately
      if (!('IntersectionObserver' in window)) {
        Array.from(images).forEach(image => preloadImage(image));
      } else {
        // It is supported, load the images
        this.observer = new IntersectionObserver(this.onImageIntersection, config);
        images.forEach(image => {
            this.observer.observe(image);
        });
      }
    },
    onImageIntersection(entries) {
      // Loop through the entries
      entries.forEach(entry => {
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
            // Stop watching and load the image
            this.observer.unobserve(entry.target);
            entry.target.src = entry.target.dataset.src.toString();
        }
      });
    },
    show_post(index) {
      // console.log(this.recent_posts[index]);
      // console.log(this.recent_posts[index].img);
      this.$router.push({
        name: 'BlogDetails', 
        params: {
          title: this.filteredBlogs[index]['title']
        }
      }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      // this.blog.img = this.filteredBlogs[index].img;
      // this.blog.title = this.filteredBlogs[index].title;
      // this.blog.content = this.filteredBlogs[index].content;
      // this.blog.by = this.filteredBlogs[index].by;
      // this.blog.date = this.filteredBlogs[index].date;
      // window.location.href = this.filteredBlogs[index].title;
    },
    load_blog_details(){
      this.spinnerOn = true;
      this.$CensePortalHttp
        .post('home/blog-list', {
          getAll: "True"
        })
        .then(response => {
          this.spinnerOn = false;
          this.recent_posts = [];
          for (var i in response.data[0]) {
            // console.log(i);
            // console.log(response.data[3][i]);
            var short = document.createElement("div");
            short.innerHTML = response.data[3][i];
            // console.log(short)
            this.recent_posts.push({
              by: "Amit",
              title: response.data[0][i],
              blog_type: response.data[1][i],
              img: response.data[2][i],
              content: response.data[3][i],
              blog_short_description: short.innerText,
              date: response.data[4][i]
            });
          }
          if(Boolean(this.recent_posts.length > 0)){
            var temp = this.recent_posts.filter(blog =>{
              return blog.title === this.title;
            });
            if(Boolean(temp.length > 0)){
              this.blog = temp[0];
            }
          }
          // setTimeout(() => {
          //   this.setIntersectionObserver();
          // }, 0);
        });
    }
  },
  metaInfo() {
    return { 
        title: this.blog.title,
        meta: [
            { name: 'description', content:  this.blog.content},
            { property: 'og:title', content: this.blog.title},
            { property: 'og:site_name', content: 'cense.ai'},
            { property: 'og:image', content: this.blog.img},
            {property: 'og:type', content: 'website'},   
            {name: 'robots', content: 'index,follow'} 
        ]
    }
  },
  computed: {
    filteredBlogs: function(){
      return this.recent_posts.filter((post) => {
        return this.search_input.toLowerCase().split(' ').every(v => post.title.toLowerCase().includes(v)) || 
          this.search_input.toLowerCase().split(' ').every(v => post.date.toLowerCase().includes(v))
      })
    }

  },
  beforeCreate() {
    // if (!this.$session.has("Blog to be displayed")) this.$router.push("blogs");
  },
  props: {
    title: {
     type: String,
     default(){
        return ''
        }
    }
  },
  watch: {
    title(){
      this.load_blog_details();
    },
  },
  created() {
    // this.blog = this.$session.get("Blog to be displayed");
    this.setIntersectionObserver();
    this.load_blog_details();
  }
};
// jQuery(".tag-line").each(function() {
//   var Width = jQuery(this);
//   var PW = Width.parent().width();
//   Width.css("max-width", PW + "px");
// });
// jQuery(function() {
//   jQuery(".fix-img").each(function() {
//     var img = jQuery(this);
//     var image_heightA = img.height();
//     var image_widthA = img.width();
//     var parent_image_widthA = img.parent().width();
//     var parent_image_heightA = img.parent().height();
//     //if(width <= height)

//     if (
//       image_heightA > parent_image_heightA &&
//       image_widthA > parent_image_widthA
//     ) {
//       img.css("width", parent_image_widthA + "px");
//       var tem_image_heightA = img.height();

//       if (tem_image_heightA > parent_image_heightA) {
//         img.css("width", "100%");
//       } else {
//         img.css("width", "auto");
//         img.css("height", "100%");
//       }
//     } else {
//       img.css("width", parent_image_widthA + "px");
//       var tem_image_heightA = img.height();

//       if (tem_image_heightA > parent_image_heightA) {
//         img.css("width", "100%");
//       } else {
//         img.css("width", "auto");
//         img.css("height", "100%");
//       }
//     }
//   });
// });
</script>

<style>
.blog-desc ul {
  margin-left: 2%;
}
</style>

<style scoped>
div {
    font-family: 'Rubik';
}
a {
    color:#3A3A3A
}
</style>